import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Expendedora } from '@shared/models/precios/Expendedora';

@Component({
  selector: 'app-lista-expendedoras',
  templateUrl: './lista-expendedoras.component.html',
  styleUrls: ['./lista-expendedoras.component.css']
})
export class ListaExpendedorasComponent {

  [x: string]: any;


  @Input() aeroplantas: Expendedora[];



  busquedaFormControl = new UntypedFormControl();


  cargandoClientes:boolean=true;
  constructor(public activeModal:NgbActiveModal)//, private aeroplantaService:AeroplantasService) { }
  {

  }

}
